import { FC } from "react";

export const SuperfestIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M7.22058 1.54722L8.43517 0L9.83691 1.37107L11.5573 0.402844L12.32 2.20539L14.2792 1.9627L14.2894 3.92274L16.1906 4.44102L15.4439 6.25984L17 7.46164L15.6126 8.86111L16.5837 10.5636L14.7657 11.3331L15.0065 13.2755L13.0325 13.2972L12.504 15.1854L10.6786 14.4527L9.46404 16L8.06232 14.6289L6.34603 15.596L5.57924 13.7946L3.62415 14.0362L3.6139 12.0761L1.71269 11.5579L2.45528 9.74015L0.90332 8.53724L2.29068 7.13779L1.31953 5.43523L3.13347 4.66689L2.89682 2.72342L4.86672 2.70282L5.3951 0.814583L7.22058 1.54722Z"
      fill="#FF0420"
    />
    <path
      d="M7.5639 2.75402L8.54991 1.49799L9.68782 2.61102L11.0844 1.82502L11.7036 3.28832L13.2941 3.09131L13.3024 4.68247L14.8458 5.1032L14.2397 6.57973L15.5029 7.55534L14.3766 8.6914L15.1649 10.0736L13.689 10.6982L13.8845 12.2751L12.282 12.2927L11.8531 13.8255L10.3712 13.2307L9.3851 14.4868L8.24723 13.3738L6.85395 14.1589L6.23147 12.6964L4.64433 12.8926L4.63601 11.3014L3.0926 10.8807L3.69544 9.40506L2.43555 8.42852L3.56181 7.29245L2.77344 5.91031L4.24599 5.28658L4.05388 3.70885L5.65305 3.69213L6.08198 2.15926L7.5639 2.75402Z"
      fill="#FFF2AF"
    />
    <path
      d="M7.90802 3.98252L8.65827 3.02679L9.52412 3.87371L10.5868 3.27564L11.0579 4.38906L12.2681 4.23916L12.2744 5.44987L13.4488 5.77001L12.9876 6.8935L13.9487 7.63584L13.0917 8.50024L13.6917 9.55195L12.5686 10.0272L12.7174 11.227L11.4981 11.2405L11.1716 12.4068L10.0441 11.9542L9.29381 12.9099L8.42796 12.063L7.36782 12.6604L6.89417 11.5477L5.68652 11.697L5.68018 10.4862L4.50581 10.166L4.9645 9.04331L4.00586 8.30023L4.86283 7.4358L4.26296 6.38413L5.38342 5.90953L5.23725 4.70905L6.45405 4.69633L6.78043 3.52997L7.90802 3.98252Z"
      fill="#69D7FF"
    />
  </svg>
);
